import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import React, { Component, Fragment } from "react";

import { AssessmentEnum, AssessmentQuestionTypeEnum } from "@/core/constants";
import {
  fetchAssessmentCrisisRisk,
  getNextQuestion,
  getPreviousQuestion,
  setSelectedOptions,
  startAssessment,
} from "@/redux/actions/patient";
import { getPatientProfile, updateReduxProfile } from "@/redux/actions/auth";
import { getQueryParams } from "@/utils/filters";
import { NavControls, QuestionV2 } from "@/components/Patient/Assessment";
import ProgressBar from "@/components/UI/ProgressBar";
import SuicidePreventionPopUp from "@/components/Screening/a5Complete/SuicidePreventionPopUp";
import { toastMessageTypes } from "@/redux/actions/toaster";

class Assessment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assessmentId: null,
      assessmentType:
        this.props.iteration || getQueryParams("assessmentType", props.location.search),
      showCrisisRisk: false,
    };
  }

  async componentDidUpdate(prevProps) {
    if (!prevProps.assessmentCompleted && this.props.assessmentCompleted) {
      if (
        ![
          "A5",
          AssessmentEnum.A5_ASSESSMENT_TYPE,
          AssessmentEnum.A5_V2_ASSESSMENT_TYPE,
          AssessmentEnum.A5R_ASSESSMENT_TYPE,
        ].includes(this.state.assessmentType)
      ) {
        this.updateProfileAndGoHome();
      }

      const searchParams = { screening_id: this.state.assessmentId };
      const dispatch = this.props.dispatch;

      fetchAssessmentCrisisRisk({ dispatch, searchParams }).then((response) => {
        if (response) {
          this.setState({
            showCrisisRisk: true,
          });
        } else {
          this.updateProfileAndGoHome();
        }
      });
    }

    if (prevProps.location.search !== this.props.location.search) {
      await this.setState({
        assessmentType:
          this.props.iteration || getQueryParams("assessmentType", this.props.location.search),
      });
      this.componentDidMount();
    }
  }

  exceptionConfig = {
    NoActiveAssessmentError: {
      errorCallback: () => this.updateProfileAndGoHome(),
      toastErrorType: toastMessageTypes.warning,
    },
  };

  componentDidMount() {
    if (this.props.profile.status === "INACTIVE") {
      this.updateProfileAndGoHome();

      return;
    }
    this.props.startAssessment(this.state.assessmentType, this.exceptionConfig);
  }

  handleNext = () => {
    let requestBody = this.makeNextQuestionRequest();

    this.props.getNextQuestion(requestBody, this.state.assessmentType, this.exceptionConfig);
    if (!this.state.assessmentId) {
      this.setState({ assessmentId: requestBody.assessment_id });
    }
  };

  handlePrev = () => {
    this.props.getPreviousQuestion(this.state.assessmentType, this.exceptionConfig);
  };

  makeNextQuestionRequest = () => {
    let currentQ = this.props.currentQuestion;
    let requestBody = {
      assessment_id: currentQ.assessment_id,
      assessment_type: currentQ.assessment_type,
      options: this.constructSelectedOptions(),
      question_id: currentQ.question_id,
    };

    return requestBody;
  };

  constructSelectedOptions = () => {
    let selectedOptionsPure = this.props.currentQuestion.options.filter((el) => {
      let found =
        this.props.selectedOptions.find((index) => {
          return index === el.index;
        }) !== undefined;

      return found;
    });

    return selectedOptionsPure;
  };

  handleSingleOptionQuestion = (singleOption) => {
    let requestBody = this.makeNextQuestionRequest();

    requestBody["options"] = [singleOption];
    this.props.getNextQuestion(requestBody, this.props.iteration, this.exceptionConfig);
    if (!this.state.assessmentId) {
      this.setState({ assessmentId: requestBody.assessment_id });
    }
  };

  render() {
    return (
      <section className="Assessment">
        {this.props.currentQuestion && (
          <Fragment>
            <div className="container">
              <div className="my-4">
                <span>Progress</span>
              </div>

              <ProgressBar height="12px" now={this.props.assessmentPerc} />

              <QuestionV2
                currentQuestion={this.props.currentQuestion}
                selectedOptions={this.props.selectedOptions}
                selectOption={(option) => {
                  if (this.props.currentQuestion.type === "single_choice") {
                    this.handleSingleOptionQuestion(option);
                  } else {
                    optionSelectHandler(option, this);
                  }
                }}
              />
            </div>

            <NavControls
              isLast={this.props.isLastQuestion}
              next={this.handleNext}
              prev={this.handlePrev}
              questionId={this.props.currentQuestion.question_id}
              selectedOptions={this.props.selectedOptions}
            />
          </Fragment>
        )}

        {this.state.showCrisisRisk && (
          <SuicidePreventionPopUp
            onCloseHandler={() => {
              this.updateProfileAndGoHome();
            }}
          />
        )}
      </section>
    );
  }

  async updateProfileAndGoHome() {
    await this.props.getPatientProfile(true);
    // TODO: Remove in https://aptihealth.atlassian.net/browse/AT1-5460
    window.localStorage.removeItem("redirectAfterAuth");
    this.props.history.push("/app/home");
  }
}

const mapStateToProps = (state) => {
  return {
    assessmentCompleted: state.patient.assessmentCompleted,
    assessmentPerc: state.patient.assessmentPerc,
    currentQuestion: state.patient.currentQuestion,
    hasAssessmentAssigned: state.patient.hasAssessmentAssigned,
    isLastQuestion: state.patient.isLastQuestion,
    lastSelectedOption: state.patient.lastSelectedOption,
    profile: state.auth.profile,
    selectedOptions: state.patient.selectedOptions,
    startRatingScale: state.patient.startRatingScale,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    ...bindActionCreators(
      {
        getNextQuestion,
        getPatientProfile,
        getPreviousQuestion,
        setSelectedOptions,
        startAssessment,
        updateReduxProfile,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Assessment);

// toggle option state
export const optionSelectHandler = (option, that) => {
  let oldSelectedOptions = that.props.selectedOptions.slice();
  let index = null;
  let foundOption = oldSelectedOptions.find((optionIndex, i) => {
    index = i;

    return optionIndex == option.index;
  });
  let isNoneType = option.type && option.type == "None";
  let isSCQ = that.props.currentQuestion.type == AssessmentQuestionTypeEnum.SINGLE_CHOICE;
  let isLastSelectedNoneType =
    that.props.lastSelectedOption &&
    that.props.lastSelectedOption.type &&
    that.props.lastSelectedOption.type == "None";

  if (isSCQ || isNoneType || isLastSelectedNoneType) {
    foundOption !== undefined ? (oldSelectedOptions = []) : (oldSelectedOptions = [option.index]);
  } else {
    foundOption !== undefined
      ? oldSelectedOptions.splice(index, 1)
      : oldSelectedOptions.push(option.index);
  }
  that.props.setSelectedOptions(oldSelectedOptions, option);
};
